import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    userCoins: [],
 };

export const userCoinsSlice = createSlice({
    name: 'userCoins',
    initialState,
    reducers: {
        setUserCoins(state, action) {
            state.userCoins = action.payload;
        },
    }
});

export default userCoinsSlice;